import { Fragment, useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { Button, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import FilePageService from '../../API/FilePage/FilePageService';

const EditInsurerProduct = (props) => {
    const { t } = useTranslation();
    const { id } = useParams();

    const { showmodal, handleModalClose, handleAddNoteModalCloseAfterAPICall, editId } = props;
    // `editId` will be passed from list page when clicking edit button

    const [formData, setFormData] = useState({
        name: "",
        risk_type: "",
        guarantee: "",
        description: "",
    });

    const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });
    const [loading, setLoading] = useState(false);

    // show alert for 2s then hide
    useEffect(() => {
        if (flashMessage.message) {
            const timer = setTimeout(() => {
                setFlashMessage({ type: "", message: "" });
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [flashMessage]);

    // fetch data when modal opens with editId
    useEffect(() => {
        if (showmodal && editId) {
            fetchInsurerProduct(editId);
        }
    }, [showmodal, editId]);

    const fetchInsurerProduct = async (productId) => {
        try {
            const response = await FilePageService.insurer_product_show(productId);
            if (response.data.status) {
                const data = response.data.insurerProduct;
                setFormData({
                    name: data.name || "",
                    risk_type: data.risk_type || "",
                    guarantee: data.guarantee || "",
                    description: data.description || "",
                });
            }
        } catch (error) {
            console.error("Error fetching product:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const EditProduct = async (e) => {
        e.preventDefault();
        if (loading) return;

        if (!formData.name || !formData.risk_type || !formData.guarantee || !formData.description) {
            setFlashMessage({ type: "error", message: t("requriedErrorMessageLabel") });
            return;
        }

        setLoading(true);

        const payload = {
            ...formData,
        };

        try {
            const response = await FilePageService.insurer_product_update(editId, payload);
            if (response.data.status) {
                setLoading(false);
                handleAddNoteModalCloseAfterAPICall();
            } else {
                setLoading(false);
                setFlashMessage({
                    type: "error",
                    message: response.data.message || t("somethingWentWrong"),
                });
            }
        } catch (error) {
            setLoading(false);
            setFlashMessage({
                type: "error",
                message: error.response?.data?.message || t("somethingWentWrong"),
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Fragment>
            <Modal className='missing-doc-modal invalid-doc-modal' show={showmodal} onHide={handleModalClose}>
                <Form onSubmit={EditProduct}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t("Edit Product")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <h2>{t("Edit Product")}</h2>

                        {flashMessage.message && (
                            <div
                                className={`mt-3 mx-w-620 alert ${flashMessage.type === "success"
                                    ? "alert-success"
                                    : "alert-danger"
                                    } text-center`}
                                role="alert"
                            >
                                {flashMessage.message}
                            </div>
                        )}

                        <div className="mt-3">
                            <Form.Group className="mb-3">
                                <Form.Label>Nom du produit</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Nom du produit"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Type de risque</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="risk_type"
                                    value={formData.risk_type}
                                    onChange={handleChange}
                                    placeholder="Type de risque"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Garantie</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="guarantee"
                                    value={formData.guarantee}
                                    onChange={handleChange}
                                    placeholder="Garantie"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    placeholder="Tapez ici..."
                                />
                            </Form.Group>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="cancel-btn" variant="primary" onClick={handleModalClose}>
                            {t("cancelLabel")}
                        </Button>
                        <Button variant="primary" type="submit" disabled={loading}>
                            Mise à jour
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </Fragment>
    );
};

export default EditInsurerProduct;
